import { Outlet } from "@tanstack/react-router";
import { SidebarProvider, SidebarInset } from "@corpuscomplete/web-ui/components/sidebar";
import { AdminSidebar } from "@corpuscomplete/web/components/admin-sidebar";

export function AdminShell() {
  return (
    <SidebarProvider className="h-svh max-h-svh overflow-hidden">
      <AdminSidebar />
      <SidebarInset className="overflow-hidden">
        <Outlet />
      </SidebarInset>
    </SidebarProvider>
  );
}
